<template>
    <div>
        <section class="filter"></section>
        <section class="timetable">
            <ul class="timetable__list-institutes institutes container">
                <li class="institutes__item item row" v-if="((searchBugs[0].length > 0))">
                    <div class="col-12 col-xl-8 container">
                        <ul class="item__list-institute institute row" style="border: none">
                            <li class="institute__item group" v-for="group in searchBugs[0]" :key="group[0]">
                                <div class="bug-group col-md-6 col-ls-4">
                                    {{ group.name }}
                                    <div class="bug-group-list">
                                        <div class="bug-group-list-item" v-for="error in group.error" :key="error[0]">
                                            {{ error[1] + ' ' + error[2] +' '+ error[3] }}
                                            <div style = "color: red;">{{ error[4] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
export default{
    computed: {
        ...mapGetters(['semestrImtIptoOchVechPrepod','semestrOrAndSessionDataTeacher']),

        searchBugs(){
            let Bugs = [];
            let bugCounter = 0;
            let allPrepod = this.semestrImtIptoOchVechPrepod?.filter(v => {
                return v.toLowerCase().includes(' '.toLowerCase())
            }).sort((a, b) => a.localeCompare(b));
            let array = allPrepod;
            array.filter(teacher => {
                let dataTeacher = this.semestrOrAndSessionDataTeacher(teacher);
                dataTeacher.filter(data => {
                    const pattern1 = /\.{2,}/;
                    const pattern2 = /\([^)]*;[^)]*\)/;
                    const pattern4 = /\)\s*,\s*[А-Я]/;
                    const pattern5 = /[А-Я][а-я]+(?:-[А-Я][а-я]+)?ё?\s+[А-Я]\.[А-Я](?!\.)/;
                    const pattern6 = /,\s*с\s+\d{2}\.\d{2}\.\d{4}/;
                    const teachersList = /[А-Я][а-я]+(?:-[А-Я][а-я]+)?ё?\s+[А-Я]\.[А-Я]\.(?:\s*,\s*[А-Яа-я]+(?:-[А-Я][а-я]+)?ё?\s+[А-Я]\.[А-Я]\.)*/;
                    const classroomPattern = /(?:[А-Яа-яA-Za-z0-9\s.,]+)/;
                    const teacherPart = new RegExp(`\\s+${teachersList.source}(?:\\s*\\,\\s*${classroomPattern.source})?(?:\\s+с\\s+\\d{2}\\.\\d{2}\\.\\d{4}\\.?)?`);
                    const firstBlock = new RegExp(`.+?${teacherPart.source}`);
                    const subBlock = new RegExp(`.+?${teacherPart.source}`);
                    const pattern7 = new RegExp(`^${firstBlock.source}(?:\\s*;\\s*${subBlock.source})*\\s*$`);
                    const pattern8 = /[А-Я][а-я]+(?:-[А-Я][а-я]+)?ё?\s+[А-Я]\.[А-Я]\.?\s*\([^)]+\)(?!(?:.*[А-Я][а-я]+ё?\s+[А-Я]\.[А-Я]\.))/;
                    const pattern9 = /\.[А-Я]\.,[А-Я][а-я]/;
                    const pattern10 = /\.[А-Я]\.,\s*$/;
                    const pattern11 = /\)\s*(?:\s*,\s*(?:[А-Яа-яA-Za-z]?\d+(?:\.\d+)?|[А-Я]{2,}))?\s*;/;
                    const pattern12 = /,\s*[А-Я]\.\d+/; 
                    const pattern13 = /\((?:лецк\.|лецк|лекц)(?!\.)\)/; 
                    const pattern14 = /\(прак(?!\.)\)/;
                    const pattern15 = /\.\s*[А-Я]\d+/;
                    const pattern16 = /\.[А-Я]\.с\s+\d{2}/;
                    //let hasSpecificError  = false;
                    let currentErrors = [];
                    const addBug = (errorText) => {
                        currentErrors.push([bugCounter++, data.day, data.time, teacher, errorText, data.dics]);
                    };
                    const subBlocksArray = data.dics.split(';');
                    subBlocksArray.forEach(block => {
                        if (block.trim().length > 0) {
                            const hasTeacherInBlock = new RegExp(teachersList.source).test(block);
                            if (!hasTeacherInBlock) {
                                addBug('В одном из блоков расписания пропущено ФИО преподавателя');
                                //hasSpecificError = true;
                            }
                        }
                    });
                    const teachersInDics = data.dics.match(new RegExp(teachersList.source, 'g')) || [];
                    if (teachersInDics.length > 0) {
                        let missingRoomDetected = false;
                        teachersInDics.forEach(tName => {
                            const roomCheckPattern = new RegExp(`${tName.replace(/\./g, '\\.')}\\s*,\\s*${classroomPattern.source}`);
                            if (!roomCheckPattern.test(data.dics)) {
                                missingRoomDetected = true;
                            }
                        });
                        if (missingRoomDetected) {
                            if (!data.room || data.room.trim() === '') {
                                addBug('Отсутствует аудитория в расписании');
                                //hasSpecificError = true;
                            }
                        }
                    }
                    if(pattern1.test(data.dics)){
                        addBug('Дублирование точек в тексте');
                    }
                    if(pattern2.test(data.dics)){
                        addBug('Точка с запятой внутри круглых скобок');
                    }
                    if(pattern4.test(data.dics)){
                        addBug('Перед ФИО обнаружена лишняя запятая');
                    }
                    if (pattern5.test(data.dics)) {
                        addBug('Отсутствует точка в конце ФИО преподавателя');
                        //hasSpecificError  = true;
                    }
                    if (pattern6.test(data.dics)) {
                        addBug('Обнаружена ошибочная запятая перед датой курса');
                        //hasSpecificError = true;
                    }
                    if (pattern8.test(data.dics)) {
                        addBug('ФИО ошибочно указано перед скобками');
                        //hasSpecificError = true;
                    }
                    if (pattern9.test(data.dics)) {
                        addBug('Отсутствует обязательный пробел после запятой между фамилиями преподавателей');
                        //hasSpecificError = true;
                    }
                    if (pattern10.test(data.dics)) {
                        addBug('После ФИО обнаружена лишняя запятая или пробелы');
                        //hasSpecificError = true;
                    }
                    if (pattern11.test(data.dics)) {
                        addBug('Пропущено ФИО преподавателя перед точкой с запятой в середине строки');
                        //hasSpecificError = true;
                    }
                    if (pattern12.test(data.dics)) {
                        addBug('Обнаружена точка в названии аудитории (например, Д.107 вместо Д107)');
                        //hasSpecificError = true;
                    }
                    if (pattern13.test(data.dics)) {
                        addBug('Неправильно написано (лекц.): обнаружена опечатка вроде (лецк.)');
                        //hasSpecificError = true;
                    }
                    if (pattern14.test(data.dics)) {
                        addBug('Отсутствует точка в (прак) или (лекц)');
                        //hasSpecificError = true;
                    }
                    if (pattern15.test(data.dics)) {
                        addBug('Нет запятой перед аудиторией');
                        //hasSpecificError = true;
                    }
                    if (pattern16.test(data.dics)) {
                        addBug('Отсутствует пробел перед предлогом "с"');
                        //hasSpecificError = true;
                    }
                    /*if (!hasSpecificError && !pattern7.test(data.dics)) {
                        addBug('Нарушена общая структура строки или порядок ФИО/аудитории');
                    }*/
                    if (currentErrors.length === 0 && !pattern7.test(data.dics)) {
                        console.log(data.dics, "\nНарушена общая структура строки или порядок ФИО/аудитории:\n", teacher, data.group, data.day, data.time);
                        addBug('Критическое нарушение структуры строки расписания');
                    }
                    if (currentErrors.length > 0) {
                        let existingGroupObj = Bugs.find(item => item.name === data.group);

                        if (existingGroupObj) {
                            existingGroupObj.error.push(...currentErrors);
                        } else {
                            Bugs.push({name: data.group, error: currentErrors});
                        }
                    }
                    
                })
            })
            //console.log(Bugs)
            return [Bugs] ?? [];
        }
    }
}
</script>